export default __webpack_public_path__ + "static/media/bg-geometry-dark.a3b1ebd2.svg";